import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { radius, fontSize } from '../../../../../common/css/setting/variable';
import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import ModuleTitle from '../modules/ModuleTitle';
import {
  HeaderStyle,
  HeadingStyle,
  HeadingTitleStyle,
  SportsNavStyle,
  SportsNavItemStyle,
  SportsBodyStyle,
  SportsListStyle
} from './sportsCommonStyle';
import SoccerGame from './SoccerGame';
import SoccerPlayer from './SoccerPlayer';

interface IProps {
  j1League: {
    isShow: boolean;
    games?: Array<{
      url: string;
      teamHome: string;
      teamVisitor: string;
    }>;
  };

  jLeagueCup: {
    isShow: boolean;
    games?: Array<{
      url: string;
      teamHome: string;
      teamVisitor: string;
    }>;
  };

  overseas: {
    isShow: boolean;
    players?: Array<{
      url: string;
      name: string;
    }>;
  };

  hasTitle: boolean; // モジュールタイトルを表示
}

const Header = styled.div<{ $hasTitle: boolean }>`
  ${HeaderStyle}
`;

const Heading = styled.div`
  ${HeadingStyle}
`;

const HeadingTitle = styled.div`
  ${HeadingTitleStyle}
`;

const NavList = styled.ul`
  ${SportsNavStyle}
`;

const NavItem = styled.li`
  ${SportsNavItemStyle}
`;

const NavLink = styled.a`
  ${pcVisitedLink}
`;

const Container = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 8px;
  }
`;

const ContainerItem = styled.div`
  & + & {
    margin-left: 8px;
  }
`;

const Body = styled.div`
  ${SportsBodyStyle}
`;

const List = styled.ul`
  ${SportsListStyle}
`;

const Title = styled.a`
  display: block;
  width: 70px;
  padding: 3px 0;
  font-size: ${fontSize.px14};
  font-weight: bold;
  text-align: center;
  border: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
  border-radius: ${radius.middleLow_common};
`;

export default class Soccer extends Component<IProps> {
  /**
   *
   */
  public render() {
    if (!this.props.j1League.isShow && !this.props.jLeagueCup.isShow && !this.props.overseas.isShow) {
      return null;
    }
    const jLeagueHeader =
      this.props.j1League.isShow || this.props.jLeagueCup.isShow ? (
        <Header $hasTitle={this.props.hasTitle}>
          <Heading>
            <HeadingTitle>スポーツナビ 今日のJリーグ試合情報</HeadingTitle>
          </Heading>
          <NavList>
            <NavItem>
              <NavLink
                href="https://soccer.yahoo.co.jp/jleague/"
                data-cl-params="_cl_vmodule:jleague;_cl_link:ysports;"
              >
                Jリーグトップ
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://soccer.yahoo.co.jp/jleague/category/j1"
                data-cl-params="_cl_vmodule:jleague;_cl_link:j1;"
              >
                J1
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://soccer.yahoo.co.jp/jleague/category/j2"
                data-cl-params="_cl_vmodule:jleague;_cl_link:j2;"
              >
                J2
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://soccer.yahoo.co.jp/jleague/category/jcup"
                data-cl-params="_cl_vmodule:jleague;_cl_link:jcup;"
              >
                Jリーグ杯
              </NavLink>
            </NavItem>
          </NavList>
        </Header>
      ) : null;

    const j1Body = this.props.j1League.isShow ? (
      <Container>
        <ContainerItem>
          <Title
            href="https://soccer.yahoo.co.jp/jleague/category/j1"
            data-cl-params="_cl_vmodule:jleague;_cl_link:j1game;_cl_position:t;"
          >
            J1
          </Title>
        </ContainerItem>
        <ContainerItem>
          <List>
            {this.props.j1League.games
              ? this.props.j1League.games.map((game, index) => {
                  return (
                    <SoccerGame
                      {...game}
                      key={index}
                      dataClParams={`_cl_vmodule:jleague;_cl_link:j1game;_cl_position:${index + 1};`}
                    />
                  );
                })
              : null}
          </List>
        </ContainerItem>
      </Container>
    ) : null;

    const jLeagueCupBody = this.props.jLeagueCup.isShow ? (
      <Container>
        <ContainerItem>
          <Title
            href="https://soccer.yahoo.co.jp/jleague/category/jcup"
            data-cl-params="_cl_vmodule:jleague;_cl_link:jcupgame;_cl_position:t;"
          >
            Jリーグ杯
          </Title>
        </ContainerItem>
        <ContainerItem>
          <List>
            {this.props.jLeagueCup.games
              ? this.props.jLeagueCup.games.map((game, index) => {
                  return (
                    <SoccerGame
                      {...game}
                      key={index}
                      dataClParams={`_cl_vmodule:jleague;_cl_link:jcupgame;_cl_position:${index + 1};`}
                    />
                  );
                })
              : null}
          </List>
        </ContainerItem>
      </Container>
    ) : null;

    const jLeagueBody =
      this.props.j1League.isShow || this.props.jLeagueCup.isShow ? (
        <Body>
          {j1Body}
          {jLeagueCupBody}
        </Body>
      ) : null;

    const overseasHeader = this.props.overseas.isShow ? (
      <Header $hasTitle={this.props.hasTitle}>
        <Heading>
          <HeadingTitle>スポーツナビ 海外サッカー 日本人選手出場試合</HeadingTitle>
        </Heading>
        <NavList>
          <NavItem>
            <NavLink href="https://soccer.yahoo.co.jp/ws/" data-cl-params="_cl_vmodule:wldsocc;_cl_link:ysports;">
              海外サッカートップ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="https://soccer.yahoo.co.jp/ws/japanese/players"
              data-cl-params="_cl_vmodule:wldsocc;_cl_link:jpplyers;"
            >
              日本人選手
            </NavLink>
          </NavItem>
        </NavList>
      </Header>
    ) : null;

    const overseasBody = this.props.overseas.isShow ? (
      <Body>
        <List>
          {this.props.overseas.players
            ? this.props.overseas.players.map((player, index) => {
                return (
                  <SoccerPlayer
                    {...player}
                    key={index}
                    dataClParams={`_cl_vmodule:wldsocc;_cl_link:player;_cl_position:${index + 1};`}
                  />
                );
              })
            : null}
        </List>
      </Body>
    ) : null;

    return (
      <Fragment>
        {this.props.hasTitle ? <ModuleTitle titleText="サッカー情報" hasPayPay={false} /> : ``}
        {jLeagueHeader}
        {jLeagueBody}
        {overseasHeader}
        {overseasBody}
      </Fragment>
    );
  }
}
